import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function addNewGroup(leagueId, groupName, groupSlogan, groupImg) {
  const token = Cookies.getToken();


  const formData = new FormData();
  formData.append('name', groupName);
  formData.append('is_active', true);
  groupImg !== null && formData.append('image', groupImg);
  formData.append('slogan', groupSlogan);

  const res = await axios({
    method: 'POST',
    url:
      process.env.REACT_APP_API_URL + `/api/league/leagues/${leagueId}/teams/`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  });

  if (res.status === 201) {
    return res;
  } else {
    return { error: res.status };
  }
}

